import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
import {
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  IconButton,
} from "@material-ui/core";
import {
  MoreHoriz,
  Check,
  DeleteForever,
  Restore,
  Edit,
  Visibility,
} from "@material-ui/icons";
import { UserDataContext } from "../../Contexts/UserDataContext";
import { roles, statuses, invoiceStatuses } from "../../Mappings";
import ApproveParcel from "./ApproveParcel";
import DeleteParcel from "./DeleteParcel";
import RestoreParcel from "./RestoreParcel";
import EditParcel from "./EditParcel";
import ViewParcel from "./ViewParcel";

const ActionMenu = (props) => {
  const { truckId, week, day, itemId, itemData, ...otherProps } = props;
  const [menuOpen, setMenuOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [action, setAction] = useState("");
  const { userData } = useContext(UserDataContext);

  const handleOpen = (event) => {
    setMenuOpen(true);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setMenuOpen(false);
    setAnchorEl(null);
  };

  const handleClick = (action) => {
    handleClose();
    setAction(action);
  };

  const lockedStatus = !(
    userData.invoiceStatuses[props.truckId][props.week] ===
      invoiceStatuses.unsubmitted ||
    userData.invoiceStatuses[props.truckId][props.week] ===
      invoiceStatuses.dpcPending
  );

  const actions = {
    approve:
      userData.roleId === roles.tollAdmin &&
      !lockedStatus &&
      (itemData.approvalState === statuses.added ||
        itemData.approvalState === statuses.changed ||
        itemData.approvalState === statuses.deleted),

    delete:
      (userData.roleId === roles.tollAdmin &&
        !lockedStatus &&
        itemData.approvalState !== statuses.deleted &&
        itemData.approvalState !== statuses.deletedApproved) ||
      (userData.roleId === roles.ownerDriver &&
        !lockedStatus &&
        itemData.approvalState !== statuses.deleted &&
        itemData.approvalState !== statuses.amended &&
        itemData.approvalState !== statuses.addedApproved &&
        itemData.approvalState !== statuses.changedApproved &&
        itemData.approvalState !== statuses.deletedApproved &&
        itemData.approvalState !== statuses.hourlyLinked),

    restore:
      !lockedStatus &&
      !itemData.userAdded &&
      ((userData.roleId === roles.ownerDriver &&
        (itemData.approvalState === statuses.changed ||
          itemData.approvalState === statuses.deleted)) ||
        (userData.roleId === roles.tollAdmin &&
          (itemData.approvalState === statuses.changed ||
            itemData.approvalState === statuses.deleted))),
    // ||
    // itemData.approvalState === statuses.amended ||
    // itemData.approvalState === statuses.changedApproved ||
    // itemData.approvalState === statuses.deletedApproved

    edit:
      !lockedStatus &&
      ((userData.roleId === roles.ownerDriver &&
        (itemData.approvalState === statuses.draft ||
          itemData.approvalState === statuses.added ||
          itemData.approvalState === statuses.changed ||
          itemData.approvalState === statuses.restored)) ||
        (userData.roleId === roles.tollAdmin &&
          (itemData.approvalState === statuses.draft ||
            itemData.approvalState === statuses.added ||
            itemData.approvalState === statuses.changed ||
            itemData.approvalState === statuses.restored ||
            itemData.approvalState === statuses.amended ||
            itemData.approvalState === statuses.addedApproved ||
            itemData.approvalState === statuses.changedApproved))),

    view: true,
  };

  return (
    <>
      <IconButton onClick={handleOpen} {...otherProps}>
        <MoreHoriz />
      </IconButton>
      <Menu open={menuOpen} anchorEl={anchorEl} onClose={handleClose}>
        {actions.view && (
          <MenuItem onClick={() => handleClick("view")}>
            <ListItemIcon>
              <Visibility />
            </ListItemIcon>
            <ListItemText primary="View" />
          </MenuItem>
        )}

        {actions.approve && (
          <MenuItem onClick={() => handleClick("approve")}>
            <ListItemIcon>
              <Check />
            </ListItemIcon>
            <ListItemText primary="Approval View" />
          </MenuItem>
        )}

        {actions.delete && (
          <MenuItem onClick={() => handleClick("delete")}>
            <ListItemIcon>
              <DeleteForever />
            </ListItemIcon>
            <ListItemText primary="Delete Item" />
          </MenuItem>
        )}

        {actions.restore && (
          <MenuItem onClick={() => handleClick("restore")}>
            <ListItemIcon>
              <Restore />
            </ListItemIcon>
            <ListItemText primary="Restore Item" />
          </MenuItem>
        )}

        {actions.edit && (
          <MenuItem onClick={() => handleClick("edit")}>
            <ListItemIcon>
              <Edit />
            </ListItemIcon>
            <ListItemText primary="Edit Item" />
          </MenuItem>
        )}
      </Menu>

      {action === "approve" && (
        <ApproveParcel
          open={true}
          onClose={() => handleClick("")}
          truckId={truckId}
          week={week}
          day={day}
          itemId={itemId}
          itemData={itemData}
        />
      )}

      {action === "delete" && (
        <DeleteParcel
          open={true}
          onClose={() => handleClick("")}
          truckId={truckId}
          week={week}
          day={day}
          itemId={itemId}
          itemData={itemData}
        />
      )}

      {action === "restore" && (
        <RestoreParcel
          open={true}
          onClose={() => handleClick("")}
          truckId={truckId}
          week={week}
          day={day}
          itemId={itemId}
          itemData={itemData}
        />
      )}

      {action === "edit" && (
        <EditParcel
          open={true}
          onClose={() => handleClick("")}
          truckId={truckId}
          week={week}
          day={day}
          itemId={itemId}
          itemData={itemData}
        />
      )}

      {action === "view" && (
        <ViewParcel
          open={true}
          onClose={() => handleClick("")}
          truckId={truckId}
          week={week}
          day={day}
          itemId={itemId}
          itemData={itemData}
        />
      )}
    </>
  );
};

export default ActionMenu;

ActionMenu.propTypes = {
  truckId: PropTypes.number.isRequired,
  week: PropTypes.number.isRequired,
  day: PropTypes.number.isRequired,
  itemId: PropTypes.string.isRequired,
};
